<template>
  <div class="view-container">
    <el-drawer :visible.sync="drawer" direction="rtl" size="550px" :modal-append-to-body="false" :before-close="handleClose">
      <BjDivider>{{ $t('goodsPage.package.Info') }} </BjDivider>
      <el-form v-if="drawer" ref="form" :disabled="pageType=='view'" label-position="top" :model="form" :rules="rules" label-width="160px" style="padding:16px;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.Name')" prop="skuName">
              <BjInput v-model="form.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.package.Name')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.SKU')" prop="skuCode">
              <BjInput v-model="form.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.package.SKU')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <!-- 新增 可以修改 -->
          <!-- <el-col :span="12" v-if="pageType=='add'">
            <el-form-item :label="$t('goodsPage.package.Method')" prop="packingMethod">
              <BjSelectLov v-model="form.packingMethod" :placeholder="$t('goodsPage.package.Method')" :option-list="MethodOption" />
            </el-form-item>
          </el-col> -->
          <!-- 编辑 不可修改 -->
          <!-- <el-col :span="12" v-if="pageType=='edit'||pageType=='view'">
            <el-form-item :label="$t('goodsPage.package.Method')" prop="packingMethod">
              <BjSelectLov disabled v-model="form.packingMethod" :placeholder="$t('goodsPage.package.Method')" :option-list="MethodOption" />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.Barcode')" prop="barCode">
              <BjInput v-model="form.barCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.package.Barcode')" clearable @keyup.enter.native="handleQuery"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.fee')" prop="activityPrice">
              <BjInputMoney :disabled="$store.getters.cusId" v-model="form.activityPrice" :maxlength="10" :placeholder="$t('goodsPage.package.fee')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!$store.getters.cusId">
            <el-form-item :label="$t('goodsPage.package.Type')" prop="packageType">
              <BjSelectLov v-model="form.packageType" :disabled="pageType=='edit'" :placeholder="$t('goodsPage.package.Type')" :option-list="TypeOption" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!$store.getters.cusId&&form.packageType=='cus'">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
              <BjSelectLov v-model="form.cusId" :disabled="pageType=='edit'" :option-list="customerList" :placeholder="$t('billingPage.CustomerName')" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!$store.getters.cusId && form.packageType=='csg'">
            <el-form-item :label="$t('goodsPage.package.Cost')" prop="costPrice">
              <BjInputMoney v-model="form.costPrice" :maxlength="10" :placeholder="$t('goodsPage.package.Cost')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!$store.getters.cusId && form.packageType=='csg'">
            <el-form-item :label="$t('goodsPage.package.Price')" prop="salesPrice">
              <BjInputMoney v-model="form.salesPrice" :maxlength="10" :placeholder="$t('goodsPage.package.Price')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.Length')" prop="length">
              <BjInputMoney v-model="form.length" :maxlength="10" :placeholder="$t('goodsPage.package.Length')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.Width')" prop="width">
              <BjInputMoney v-model="form.width" :maxlength="10" :placeholder="$t('goodsPage.package.Width')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.Height')" prop="height">
              <BjInputMoney v-model="form.height" :maxlength="10" :placeholder="$t('goodsPage.package.Height')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('goodsPage.package.Weight')" prop="weight">
              <BjInputMoney v-model="form.weight" :maxlength="10" :placeholder="$t('goodsPage.package.Weight')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="foot">
        <el-button type="danger" @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button :disabled="pageType=='view'" type="primary" @click="onComfirm">{{ $t('okText') }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>

import { goodsApi } from '@/api';
export default {
  props: {
    customerList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 表单参数
      drawer: false,
      pageType: null,
      MethodOption: [
        { label: this.$t('goodsPage.package.order'), value: 'order' },
        { label: this.$t('goodsPage.package.product'), value: 'product' },
      ],
      TypeOption: [
        { label: this.$t('goodsPage.package.csg'), value: 'csg' },
        { label: this.$t('goodsPage.package.cus'), value: 'cus' },
      ],
      form: {
        skuName:null,
        skuCode:null,
        // packingMethod:null,
        packageType: !this.$store.getters.cusId?'csg':null,
        cusId: this.$store.getters.cusId || null,
        barCode:null,
        activityPrice:null,
        costPrice:null,
        salesPrice:null,
        length:null,
        width:null,
        height:null,
        weight:null,
      },
    };
  },
  computed: {
    rules() {
      const validateSKUCode = (rule, value, callback) => {
        this.$nextTick(() => {
          const reg = /^[`~!@#$%^&*()_+<>?":| {}\/\[\]\\\-+=,.\/;'*0-9A-Za-z]*$/;
          if (!this.form.skuCode) {
            callback(new Error(this.$t('inputText')));
          }
          if(!reg.test(this.form.skuCode) || /\s/.test(this.form.skuCode)){
            callback(new Error(`Package SKU ${this.$t('formatErrorText')}`));
          }
          callback();
        });
      };
      const validateBarCode = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.barCode) {
            callback(new Error(this.$t('inputText')));
          }
          if(/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(this.form.barCode) || this.form.barCode.length>14){
            callback(new Error(`Package Barcode ${this.$t('formatErrorText')}`));
          }
          callback();
        });
      };
      return {
        skuName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuCode: [{ required: true, validator: validateSKUCode, trigger: 'blur' }],
        // barCode: [{ required: true, validator: validateBarCode, trigger: 'blur' }],
        cusId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        // packingMethod: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        packageType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        costPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        salesPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        length: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        width: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        height: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        weight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
    },
  },
  methods: {
    // 确定按钮
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(!this.$store.getters.cusId&&this.form.packageType == 'csg'){
            this.form.cusId = null
          }else if(!this.$store.getters.cusId&&this.form.packageType == 'cus'){
            this.form.costPrice = null
            this.form.salesPrice = null
          }else if(this.$store.getters.cusId){
            this.form.packageType = 'cus'
          }
          if(this.form.id){
            goodsApi.checkBarCodeNew({barCode: [this.form.barCode], skuCode: [this.form.skuCode],skuId:this.form.id,checkType:2}).then(res => {
              if (!res.failed) {
                setTimeout(() => {
                  const obj = Object.assign({}, this.form);
                  this.$emit('handleConfirm', obj);
                }, 300);
              }
            });
          }else{
            goodsApi.checkBarCodeNew({barCode: [this.form.barCode], skuCode: [this.form.skuCode],checkType:1}).then(res => {
              if (!res.failed) {
                setTimeout(() => {
                  const obj = Object.assign({}, this.form);
                  this.$emit('handleConfirm', obj);
                }, 300);
              }
            });
          }
        }
      });
    },
    /** 关闭弹窗 */
    handleClose() {
      this.form={
        skuName:null,
        skuCode:null,
        // packingMethod:null,
        packageType: !this.$store.getters.cusId?'csg':null,
        cusId: this.$store.getters.cusId || null,
        barCode:null,
        activityPrice:null,
        costPrice:null,
        salesPrice:null,
        length:null,
        width:null,
        height:null,
        weight:null,
      }
      this.drawer = false;
    },
  },
};
</script>
<style lang="scss">
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
